import React from 'react';

import { FilterStorageContext } from 'src/providers/FilterStorageProvider';

export const useFilterStorage = () => {
  return React.use(FilterStorageContext);
};
